








import { bookGoodsModelProvider } from '../model'
import { defineClassComponent } from '@/hooks'
import { navigateBack } from '@/router'

export default defineClassComponent(
  () =>
    class {
      bookGoodsModel = bookGoodsModelProvider.inject()

      handleBackClick = () => {
        navigateBack()
      }
    },
)
